exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".text-icon-1{\n  fill:#f9fbfc;\n}\n\n.text-icon-2{\n  isolation:isolate;\n}\n\n.text-icon-3{\n  fill:#bdc4c9;\n}", ""]);
